export function getView(type) {
  return type && type !== 'wait'
}
